exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".is-disabled[data-v-374099a1]:hover{cursor:not-allowed}", ""]);

// exports
